import { RouteConfig } from 'vue-router';
import { LazyLoadRoute } from '@shared/router/util';
import { store } from '@shared/store';

export const SettingsRoutes: RouteConfig[] = [
    {
        name: 'Settings',
        path: '/settings',
        component: () => LazyLoadRoute(import('./Settings.vue')),
        beforeEnter(to, from, next) {
            if (store.getters['isAuthenticated'])
                return next();

            return next('/authentication/signin');
        }
    },
];
